// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Components
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    colorFrom: string;
    colorTo: string;
    disableHover?: boolean;
    icon: any;
    label?: string;
    onClick?: () => void;
    title: string;
    value: string;
}

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Component StatCard
 */
export default connect<{}, {}, Props>((state) => state)(class StatCard extends React.Component<Props, {}> {

    /**
     * Creates an instance of StatCard.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
    }

    /**
     * @description Render the AppBar Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        return (
            <div style={{marginTop: 32}}>
                <Card
                    onClick={this.props.onClick}
                    className={this.props.disableHover ? "" : "mouse-hover"}
                    style={{
                        marginBottom: 24,
                        overflow: "inherit",
                        position: "relative"
                    }}>
                    <div style={{
                        alignItems: "center",
                        background: `linear-gradient(45deg, ${this.props.colorFrom} 30%, ${this.props.colorTo} 90%)`,
                        borderRadius: 5,
                        boxShadow: "0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)",
                        display: "flex",
                        height: 100,
                        justifyContent: "center",
                        left: 20,
                        position: "absolute",
                        top: -20,
                        width: 100
                    }}>
                        <Icon style={{ color: "#fff", fontSize: 54 }}>{this.props.icon}</Icon>
                    </div>
                    <CardContent>
                        <Typography variant="subheading" color="textSecondary" align="right">
                            {this.props.title}
                        </Typography>
                        <Typography variant="headline" component="h2" align="right">
                            {this.props.value}
                        </Typography>
                    </CardContent>
                </Card>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/StatCard.tsx